export const RECEIVE_SHOPS = 'RECEIVE_SHOPS';